import { render } from "./field_privileges.vue?vue&type=template&id=5b7885af"
import script from "./field_privileges.js?vue&type=script&lang=js"
export * from "./field_privileges.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__